module.exports = {"441402004":"江南街道","441402006":"金山街道","441402007":"西郊街道","441402102":"三角镇","441402103":"长沙镇","441402105":"城北镇","441402106":"西阳镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441402.json
// module id = 2024
// module chunks = 0